import { ChangeEvent } from "react";
import { useCustomNavigation } from "../../../hooks/useCustomNavigation/useCustomNavigation";

const ManualNavigation = () => {
  const { customNavigation } = useCustomNavigation();

  const stepList = [
    { label: "PersonalData", step: "PersonalData" },
    { label: "PersonalDataAdditional", step: "PersonalDataAdditional" },
    { label: "Address", step: "Address" },
    { label: "EmploymentDetails", step: "EmploymentDetails" },
    { label: "InformationRecap", step: "InformationRecap" },
    { label: "ContractView", step: "ContractView" },
    { label: "VideoIdentification", step: "VideoIdentification" },
    { label: "SuccessVideoId", step: "SuccessVideoId" },
    { label: "FailureVideoId", step: "FailureVideoId" },
    { label: "MissingData", step: "MissingData" },
    {
      label: "VideoIdentificationUnavailable",
      step: "VideoIdentificationUnavailable",
    },
    { label: "GenericError", step: "GenericError" },
  ];

  const changeStepHandler = (e: ChangeEvent<HTMLSelectElement>) => {
    customNavigation(e.target.value);
  };

  return (
    <select
      name="steps"
      id="steps"
      style={{ position: "fixed", top: "80px", right: "10px" }}
      onChange={changeStepHandler}
    >
      <>
        {stepList.map((step) => {
          return (
            <option value={step.step} key={step.step}>
              {step.label}
            </option>
          );
        })}
      </>
    </select>
  );
};

export default ManualNavigation;
